<template>
  <div id="specific-info"
       class="part">
    <template v-if="isEdit!=='specific'">
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width:200px">Journal Would Like to Review</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 220px)"
             v-if="data.reviewerJournalList && data.reviewerJournalList.length">
          <span v-for="(item,index) in data.reviewerJournalList"
                :key="item.id+index">{{item.name}}<font v-if="data.reviewerJournalList.length>1 && index != data.reviewerJournalList.length-1">, </font> </span>
        </div>
        <div class="ipub-block__font"
             style="width:calc(100% - 220px)"
             v-else>
          --
        </div>
      </div>
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width:200px">Review Frequency</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 220px)">{{reviewFrequency[data.frequencyCode]||'--'}}</div>
      </div>
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width:200px">Reviewed Journal</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 220px)">{{data.reviewJournal||'--'}}</div>
      </div>
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width:200px">CV</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 220px)">
          <ipub-label v-if="data.rcv"
                      type="link"
                      size="small">
            <a class="ipub-c-p link-color"
               @click="goToPage(`${domain}/${data.rcv}`, data.rcvName)">
              {{data.rcvName || '--'}}
              <ipub-icon type="iconDownload1" />
            </a>
          </ipub-label>
          <font v-else>--</font>
        </div>
      </div>
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width:200px">Research Keywords</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 220px)">{{data.keyword?data.keyword:'--'}}
        </div>
      </div>
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width:200px">Remark</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 220px)">{{data.remark || '--'}}
          <!-- <div v-html="data.remark"
               v-if="data.remark"></div>
          <div v-html="data.remark"
               v-else>--</div> -->
        </div>
      </div>
    </template>
    <template v-else>
      <ipub-form ref="specific-form"
                 :model="form"
                 :rules="rules">
        <ipub-form-item label="Journal(s) Would Like to Review"
                        prop="reviewerJournalIdList">
          <!-- {{form.reviewerJournalIdList}} -->
          <ipub-select placeholder="Journal(s) Would Like to Review"
                       :options="journalList"
                       mode="multiple"
                       optionKey="id"
                       v-model="form.reviewerJournalIdList" />
        </ipub-form-item>
        <ipub-form-item prop="reviewJournal"
                        label="">
          <slot name="title">
            <div class=" ipub-p2 fw-bd mar-b-10">
              Reviewed Journal(s)
              <font class="link-color ipub-cursor-pointer mar-l-20"
                    @click="addMore('reviewJournals')">
                <ipub-icon type="iconAdd" />
                <span class="mar-l-8">Add New Reviewed Journal</span>
              </font>
            </div>
          </slot>
          <div v-for="(item, index) in form.reviewJournals"
               class="mar-b-10"
               :key="'form.reviewJournals'+index">
            <ipub-input placeholder="Reviewed Journal"
                        suffixIcon="iconClose"
                        @blur="getMore('reviewJournal')"
                        @iconClick="delMore('reviewJournals',index)"
                        v-model.trim="form.reviewJournals[index]" />
          </div>
          <!-- <ipub-button type="primary"
                       icon="iconAdd"
                       @click="addMore('reviewJournals')"
                       style="width:240px"
                       plain>Add Reviewed Journal</ipub-button> -->
        </ipub-form-item>
        <ipub-row :gutter="20">
          <ipub-col :span="6">
            <ipub-form-item prop='orcid'
                            label="Review Frequency">
              <ipub-select v-model="form.frequencyCode"
                           placeholder="Title">
                <ipub-select-option v-for="(value) in reviewFrequencyList"
                                    v-show="value.enabled"
                                    :key="value.id"
                                    :value="value.code">
                  {{ value.name }}
                </ipub-select-option>
              </ipub-select>
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="6">
            <ipub-form-item prop="rcv">

              <div class="mar-b-10 ipub-p2 fw-bd relative"
                   slot="label">
                CV (Reviewer)
                <ipub-tooltip placement="right"
                              type="dark"
                              class="mar-l-10">
                  <div slot="title">PDF</div>
                  <ipub-icon type="iconInfo" />
                </ipub-tooltip>
                <!-- <div class="right-option">
                  <ipub-upload class="ipub-c-p"
                               @change="(e)=>{handleUpload('rcv', e)}">
                    <a class="link-color">Upload</a>
                  </ipub-upload>
                </div> -->
              </div>

              <ipub-upload-input :file="form"
                                 _name="rcvName"
                                 _path="rcv"
                                 class="mar-b-20"
                                 :loading="false"
                                 :domain="domain"
                                 @delete="delFile('rcv')"
                                 @change="(e)=>{handleUpload('rcv', e)}" />
              <!-- <div class="ipub-line-block ipub-border relative">
                <div style="width: calc(100% - 60px)">
                  <a @click="goToPage(`${domain}/${form.rcv}`, form.rcvName)"
                     v-if="form.rcvName">{{form.rcvName}}</a>
                  <ipub-upload v-else
                               class="ipub-c-p"
                               style="width:100%"
                               @change="(e)=>{handleUpload('rcv', e)}">
                    <a class="line-color">Upload Curriculum Vitae (Reviewer)</a>
                  </ipub-upload>
                </div>
                <div class="right-option ipub-p4 flex"
                     v-if="form.rcvName"
                     style="right: 10px">
                  <ipub-tooltip placement="bottom">
                    <div slot="title">
                      Replace
                    </div>
                    <ipub-upload v-if="true"
                                 class="line-h-40"
                                 @change="(e)=>{handleUpload('rcv', e)}">
                      <a>
                        <ipub-icon style="font-size:16px"
                                   type="iconReplace" />
                      </a>
                    </ipub-upload>
                  </ipub-tooltip>
                  <div style="padding: 0 4px"
                       class="line-color line-h-40">|</div>
                  <ipub-tooltip placement="bottom">
                    <div slot="title">
                      Delete
                    </div>
                    <a class="line-h-40"
                       @click="delFile('rcv')">
                      <ipub-icon style="font-size:16px"
                                 type="iconDelete" />
                    </a>
                  </ipub-tooltip>
                </div>
              </div> -->
            </ipub-form-item>
          </ipub-col>

        </ipub-row>
        <ipub-form-item label="Research Keywords"
                        prop="keywords">
          <ipub-input placeholder="Keywords can be separated by a semicolon or carriage return"
                      tag
                      v-model.trim="form.keywords" />
        </ipub-form-item>
        <ipub-form-item label="Remark"
                        prop="remark">
          <ipub-textarea placeholder="Remark"
                         tag
                         v-model="form.remark" />
        </ipub-form-item>
      </ipub-form>
      <div class="btns">
        <ipub-button plain
                     style="width:180px"
                     type="primary"
                     @click="back">Cancel</ipub-button>
        <ipub-button style="width:180px;margin-left:20px"
                     type="primary"
                     @click="save">Save</ipub-button>
      </div>
    </template>
  </div>
</template>

<script>
import journal from '@/api/journal'
import { getUploadConfig } from '@/utils/upload'
import help from '@/utils/help'
import { mapGetters } from 'vuex'
import person from '@/api/person'
import { settingOption } from '@/api/setting'

export default {
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    isEdit: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      // isEdit: false,
      form: {
        hindexed: false,
        affiliations: [''],
        reviewJournals: [''],
      },
      rules: {},
      degreesList: [],
      journalList: [],
      reviewFrequencyList: []
    }
  },
  computed: {
    ...mapGetters({
      domain: 'getDomain',
      language: 'getLanguage',
      title: 'getTitle',
      country: 'getCountry',
      degree: 'getDegree',
      reviewFrequency: 'getReviewFrequency',
      // role: 'getUser'
    })
  },
  watch: {
    isEdit (val) {
      if (val === 'specific') {
        const data = JSON.parse(JSON.stringify(this.data))
        data.keywords = data.keyword ? data.keyword.split(';') : []
        this.form = data
        this.getData()
      }
    },
  },
  //
  mounted () {
    this.getJournalList()
  },
  methods: {
    async getJournalList () {
      this.journalList = await journal.getAll({
        released: true
      })

    },
    async getData () {
      const reviewFrequencyList = await settingOption.get({ type: 'REVIEW_FREQUENCY' })
      // console.log(data3, 'data3')
      this.reviewFrequencyList = reviewFrequencyList
    },

    addMore (key) {
      this.form[key].push('')
    },
    delMore (key, index) {
      if (this.form[key].length === 1) {
        return
      }
      this.form[key].splice(index, 1)
    },
    getMore (key) {
      const arr = []
      this.form[key + 's'].forEach(item => {
        if (item) {
          arr.push(item)
        }
      })
      this.form[key] = arr.join(';')
    },

    async handleUpload (key, files) {
      const file = files[0]
      const pdfFiles = ['rcv, cv']
      const pdfTypes = ['application/pdf']
      let rightType = true
      if (pdfFiles.includes(key)) {
        rightType = pdfTypes.includes(file.type)
      }
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      }
      const MS = 2
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
        })
        return false
      }
      const url = await getUploadConfig(
        file,
        `${this.publisherId}/profile/${this.data.id}/${key}/${help.guid()}`
      )

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }

      this.$set(this.form, key + 'Name', file.name)
      this.$set(this.form, key, url)
    },

    delFile (key) {
      this.form[key] = ''
      this.form[key + 'Name'] = ''
    },

    goToPage (val, name) {
      help.download(val, name)
    },

    editInfo () {
      this.isEdit = true
    },

    async save () {
      const flag = this.$refs['specific-form'].validate()
      let keywordList = []
      keywordList = this.form.keywords.map(item =>
        item.trim()
      )
      this.form.keyword = keywordList
        ? keywordList.join(';')
        : ''
      if (flag) {
        await person.editReviewer(this.form.id, this.form)
        this.$message.success({
          title: 'Success',
          content: 'This User has been saved!'
        })
        this.$emit('confirm')
      }
    },

    back () {
      this.$emit('cancel')
    },

    getRules () {
      this.rules = {
        remark: [
          {
            max: 512,
            message: `Remark length must not be more than 512 digits`
          }
        ]
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.part {
  padding: 4px 16px;
}
</style>
